import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 relative overflow-hidden bg-secondary-500">
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-background-50 mb-4">
          准备好开始阅读了吗？
        </h2>
        <p className="text-background-50/70 text-sm md:text-base mb-8 max-w-lg mx-auto">
          加入韩漫之家，发现海量免费韩漫。随时随地，畅读无忧。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/category/all"
            className="px-8 py-3 rounded-full bg-background-50 text-secondary-600 text-sm font-semibold hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer"
          >
            立即浏览全部漫画
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full border border-background-50/30 text-background-50 text-sm font-semibold hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}